// extracted by mini-css-extract-plugin
export default {"addToCartControl":"SZ-z","giftCard":"TZ-z","btnContainer":"UZ-z","cartButton":"VZ-z","disabled":"WZ-z"};